module.exports = __webpack_public_path__ + "static/img/备案图标.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/备案图标.png
// module id = xNU4
// module chunks = 23